var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React from "react";
import i18next from "i18next";
import { register } from "frontend/src/api/auth";
import { viewerSet } from "frontend/src/domain/session/model";
import { isValidEmail } from "frontend/src/lib/is-valid-email";
import { locales } from "frontend/src/domain/localization/i18n";
import { Role } from "frontend/src/shared/types/role";
import { useViewerLanguage } from "frontend/src/domain/localization";
var validations = [
    {
        key: "email",
        message: "emailMissing",
        check: function (form) { return form.email.length > 0; },
    },
    {
        key: "password",
        message: "passwordMissing",
        check: function (form) { return form.password.length > 0; },
    },
    {
        key: "email",
        message: "incorrectEmail",
        check: function (form) { return isValidEmail(form.email); },
    },
];
export var usePageModel = function () {
    var _a = __read(React.useState(""), 2), email = _a[0], setEmail = _a[1];
    var _b = __read(React.useState(""), 2), password = _b[0], setPassword = _b[1];
    var _c = __read(React.useState(Role.BusinessOwner), 2), role = _c[0], setRole = _c[1];
    var _d = __read(React.useState(false), 2), isSubmitting = _d[0], setSubmitting = _d[1];
    var _e = __read(React.useState({}), 2), errors = _e[0], setErrors = _e[1];
    var lang = useViewerLanguage();
    var validate = function () {
        var e_1, _a;
        var _b;
        var isValid = true;
        var errors = { email: [], password: [] };
        try {
            for (var validations_1 = __values(validations), validations_1_1 = validations_1.next(); !validations_1_1.done; validations_1_1 = validations_1.next()) {
                var validation = validations_1_1.value;
                if (!validation.check({ email: email, password: password })) {
                    (_b = errors[validation.key]) === null || _b === void 0 ? void 0 : _b.push(i18next.t("pages.register.errors.".concat(validation.message), {
                        ns: locales.namespaces.guest,
                    }));
                    isValid = false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (validations_1_1 && !validations_1_1.done && (_a = validations_1.return)) _a.call(validations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!isValid) {
            setErrors(errors);
        }
        return isValid;
    };
    var submit = function (evt) {
        evt.preventDefault();
        setErrors({});
        if (!validate()) {
            return;
        }
        setSubmitting(true);
        register({ login: email, password: password, role: role, lang: lang })
            .then(function (response) {
            setSubmitting(false);
            if (response.type === "fail") {
                setErrors(response.payload);
            }
            if (response.type === "success") {
                viewerSet(response.payload);
            }
        })
            .catch(function () {
            setSubmitting(false);
            setErrors({ unknown: true });
        });
    };
    var onEmailChange = function (evt) {
        return setEmail(evt.target.value);
    };
    var onPasswordChange = function (evt) {
        return setPassword(evt.target.value);
    };
    var onRoleChange = function (evt) {
        var value = evt.target.value;
        if (value === Role.BusinessOwner || value === Role.Rightholder) {
            setRole(value);
        }
    };
    return {
        submit: submit,
        email: { value: email, onChange: onEmailChange },
        password: { value: password, onChange: onPasswordChange },
        role: { value: role, onChange: onRoleChange },
        errors: errors,
        isSubmitting: isSubmitting,
    };
};
